import request from '@/utils/request'

// 快递单号查询
export function getFastMailInfo(data) {
  return request({
    url: '/promotion/smart/getFastMailInfo',
    method: 'post',
    data
  }).then(res => res.data.result || {})
}
